
import {empty} from "./functions"
import {createEvent, restore}  from "effector";
import { unpackServerData } from "./functions";
import axios from "axios";
import {createPathByActivities} from "./activities";
import { getUuidAndSession } from "./localStorage";
import { getCustomUserAgent } from "./customUserAgent";
import { $selectedAccountId } from "./accounts2";

interface INotifyData {
  data: object;
  canInterruptUser: boolean;
}

export const setNotifyData = createEvent<INotifyData>();
export const $notifyData = restore<INotifyData>(setNotifyData, 
  {
    data: {},
    canInterruptUser: false
  });

  export function clearNotifyData() {
    setNotifyData({data: {}, canInterruptUser: false })
  }


export function  askNotificationGranted() {
  // Notification.requestPermission().then((permission) => {
  //   //console.log('askNotificationGranted:result:', permission);
  // }).catch(e => {
  //   console.log('askNotificationGranted:error:', e);
  // })
}

export function requestFcmToken() {
  // requestFcmTokenPromise().then((payload) => {
  //   //console.log("requestFcmToken:token:", payload)
  //   localStorage.setItem('INSTANCE_TOKEN', payload)
  //   sendFCMToken2server(payload as string)
  // }).catch((err) => {
  //   console.log("requestFcmToken:error:", err)
  // });
}

export function deleteFcmToken(updateAfter: boolean = false) {
  // deleteFcmTokenPromise().then((isDeleted) => {
  //   //console.log("deleteFcmToken:result:", isDeleted)
  //   if(updateAfter) requestFcmToken()
  // }).catch((err) => {
  //   console.log("deleteFcmToken:error:", err)
  // });
}

export function onMessageFromServer() {
  /*onServerMessagePromise().then(payload => {
    console.log("onMessageFromServer:result:", payload)
    
    //registration.showNotification(payload.data.title, payload.data);
    navigator.serviceWorker.getRegistration('/firebase-cloud-messaging-push-scope').then((registration) => {
      //@ts-ignore
			registration.showNotification(payload.data.title, payload.data);
      console.log("onMessageFromServer:navigator.serviceWorker.getRegistration:", payload)
		  });
  }).catch(err => {
    console.log("onMessageFromServer:error:", err)
  })*/
}

export function notificationSubscribe() {
  onMessageFromServer()
  askNotificationGranted()
  requestFcmToken()
  /*onMessageListener()
    .then((payload) => {
      const { title, body } = payload.data;
      toast.info(`${title}; ${body}`);
      console.log("toast:front:", title, body)
    })
    .catch((err) => {
      toast.error(JSON.stringify(err));
      console.log("toast:front:e:", JSON.stringify(err))
    });*/

} 

interface ISentFCMToken2server {
  inProgress: boolean,
  failMsg: string,
}

export const setSendFCMToken2server = createEvent<ISentFCMToken2server>();
export const $sendFCMToken2server = restore<ISentFCMToken2server>(setSendFCMToken2server, {inProgress: false, failMsg: ""});

export function sendFCMToken2server(token: string) {
  setSendFCMToken2server({inProgress: true, failMsg: ""})
  axios.post("https://izba.kras-abs.ru/api/v3/auth/setToken", {
    ...getUuidAndSession(),
    token: token,
    account_id:$selectedAccountId.getState()
    },{
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        "Custom-User-Agent": getCustomUserAgent(),
      }
    }).then((resp) => {
      // let data = unpackServerData(resp.data, "setToken")
      //console.log("extarcted_demands:success:", resp)
      if(resp.data.failMsg && !empty(resp.data.failMsg)) {
        setSendFCMToken2server({inProgress: false, failMsg: ""})
      } else{
        setSendFCMToken2server({inProgress: false, failMsg: resp.data.failMsg})
      }
    }).catch(e => {
      let msg = e.message
      console.log("extarcted_demands:error1:", e)
      if(e.response && e.response.data) {
        let data = unpackServerData(e.response.data)
        if(data.failMsg != "") {
          setSendFCMToken2server({inProgress: false, failMsg: data.failMsg})
          return 
        }
      }
      setSendFCMToken2server({inProgress: false, failMsg: msg})
    })
}

export function onNotificationFromServerCome (event:MessageEvent<any>) {
  //console.log("notificationCome:event:", event)
  let messageType: string = event.data.messageType
  if(messageType == "notification-clicked") {
    let pathToGo = createPathByActivities(event.data.data as object)
    //console.log("notificationCome:notification-clicked:pathToGo:", pathToGo)
    setNotifyData({data: {"pathTogo": pathToGo}, canInterruptUser: true})
  } else if(messageType == "push-received") {
    //console.log("notificationCome:push-received")
    let notf = new Notification(event.data.notification.title, event.data)
    notf.onclick =  (e) => {
      //console.log("onpushCLicked:", e)
      //@ts-ignore
      let pathToGo = createPathByActivities(e.currentTarget.data as object)
      console.log("notificationCome:push-received:pathToGo:", pathToGo)
      setNotifyData({data: {"pathTogo": pathToGo}, canInterruptUser: true})
    }
    //console.log("notf:", notf)
  }
}


/*
export async function notificationPermission() {
  let permission = {granted: false, errMsg: ""} as INotificationPermissionResult;
  try {
    if(Notification.permission === 'granted') {
      permission.granted = true
      console.log('Notification permission already granted');
    } else {
      const msg = firebase.messaging()
      msg.usePublicVapidKey("BKNf0lAUm5s6Cb87ICD2c84FNEsL8H__fKDZJCqY4qwnqPVj4q8BT_o5x4dHBfjMi9sI-ZvuhEIskjmI6nM8bgw")
      await msg.requestPermission();
      if (localStorage.getItem('INSTANCE_TOKEN') !== null) {
        permission.granted = true
        console.log('Token found in localStorage(INSTANCE_TOKEN)');
      } else {
          const token = await msg.getToken(); // returns the same token on every invocation until refreshed by browser
          //await this.sendTokenToDb(token);
          localStorage.setItem('INSTANCE_TOKEN', token);
          permission.granted = true
          console.log('Got new token');
      }
    }     
  } catch (err) {
    permission.granted = false
      console.log(err);
      if (err.hasOwnProperty('code') && err.code === 'messaging/permission-default') {
        permission.errMsg = 'You need to allow the site to send notifications'
        console.log('You need to allow the site to send notifications:', err);
      }
      else if (err.hasOwnProperty('code') && err.code === 'messaging/permission-blocked') {
        permission.errMsg = 'Currently, the site is blocked from sending notifications. Please unblock the same in your browser settings'
        console.log('Currently, the site is blocked from sending notifications. Please unblock the same in your browser settings', err);
      } else {
        permission.errMsg = 'Unable to subscribe you to notifications'
        console.log('Unable to subscribe you to notifications', err);
      }
  } finally {
      return permission;
  }
}
*/